import { useState } from 'react';
import { Sun, Moon, Monitor } from 'lucide-react';
import { getTheme, setTheme, type Theme } from '../lib/theme';

// Light / Dark / Auto picker. Persists to localStorage and flips the `dark` class.
export function ThemeToggle() {
  const [theme, setT] = useState<Theme>(() => getTheme());
  const opts: { v: Theme; icon: JSX.Element; label: string }[] = [
    { v: 'light', icon: <Sun size={14} />, label: 'Light' },
    { v: 'dark', icon: <Moon size={14} />, label: 'Dark' },
    { v: 'system', icon: <Monitor size={14} />, label: 'Auto' },
  ];
  return (
    <div className="inline-flex rounded-lg border border-slate-200 bg-white p-0.5">
      {opts.map((o) => (
        <button
          key={o.v}
          type="button"
          aria-label={`Theme: ${o.label}`}
          title={o.label}
          onClick={() => {
            setTheme(o.v);
            setT(o.v);
          }}
          className={`flex items-center gap-1 rounded-md px-2 py-1 text-xs font-medium transition ${
            theme === o.v ? 'bg-brand text-white' : 'text-ink-muted hover:text-navy-900'
          }`}
        >
          {o.icon}
          <span className="hidden sm:inline">{o.label}</span>
        </button>
      ))}
    </div>
  );
}
